import axios from 'axios';
const api = axios.create ({baseURL: 'https://trabalho.aparecida.go.gov.br/wp-json/wp/v2'});
export default api; 